"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApexDomain = exports.startsWithOneOf = exports.deepCopy = exports.getUnique = void 0;
var slds_1 = require("../slds");
/**
 * Get unique elements of an array
 */
function getUnique(array) {
    var u = {};
    var a = [];
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var item = array_1[_i];
        if (u.hasOwnProperty(item)) {
            continue;
        }
        a.push(item);
        u[item] = 1;
    }
    return a;
}
exports.getUnique = getUnique;
/**
 * Helper to deep copy an object
 */
function deepCopy(o) {
    if (o === undefined || o === null) {
        return null;
    }
    return JSON.parse(JSON.stringify(o));
}
exports.deepCopy = deepCopy;
/**
 * Returns true if a string starts with one of the strings in an array
 */
function startsWithOneOf(target, array) {
    var len = parseInt(array.length, 10) || 0;
    if (len === 0) {
        return false;
    }
    var k = 0;
    var currentElement;
    while (k < len) {
        currentElement = array[k];
        if (target.startsWith && target.startsWith(currentElement)) {
            return true;
        }
        k++;
    }
    return false;
}
exports.startsWithOneOf = startsWithOneOf;
/**
 * When we set the visitor ID cookie, we want to set it on the apex domain, not the specific domain. This allows all
 * domains the customer has associated with the apex domain to share a visitor ID value. We consider this to not
 * violate privacy because presumably, any subdomains are owned by the same customer that owns the apex domain. They
 * presumably already have the ability to track shoppers accross their websites. We're matching that capability, but
 * going no further. For example, we aren't tracking shoppers accross different apex domains.
 * @param window An object conforming the Window interface of web browsers.
 */
function getApexDomain(window) {
    var host = window.location.hostname;
    if (host.indexOf('.') < 0) {
        // No . so do no split.
        return host;
    }
    var split = host.split('.');
    var hostLength = split.length;
    var apex = split[hostLength - 2] + "." + split[hostLength - 1];
    if (slds_1.SLDs.indexOf(apex) >= 0) {
        return split[hostLength - 3] + "." + apex;
    }
    return apex;
}
exports.getApexDomain = getApexDomain;
;
